export default __webpack_public_path__ + "static/mockStress2-c0b089711b9992289406995f4d5201cd.png";